/**
 * Collection Links Component - UNIVERSAL VERSION
 * No external theme dependencies.
 */
class CollectionLinks extends HTMLElement {
  constructor() {
    super();
    this.refs = {
      container: null,
      links: [],
      images: [],
      slideshow: null
    };
  }

  connectedCallback() {
    // Czekamy na wyrenderowanie DOM
    setTimeout(() => {
      this.init();
    }, 100);
  }

  init() {
    this.refs.container = this.querySelector('[ref="container"]');
    this.refs.links = Array.from(this.querySelectorAll('.collection-links__link'));
    this.refs.images = Array.from(this.querySelectorAll('[ref="slides[]"]'));
    this.refs.slideshow = this.querySelector('slideshow-component');

    if (this.refs.links.length === 0) return;

    // Nasłuchiwanie zdarzeń
    this.refs.links.forEach((link, index) => {
      link.addEventListener('mouseenter', (e) => this.select(index, e));
      link.addEventListener('focus', (e) => this.select(index, e));
      
      link.addEventListener('mouseleave', () => {
        if (this.getAttribute('layout') !== 'spotlight') {
          this.clearSelections();
        }
      });
    });

    this.addEventListener('keydown', (e) => this.handleKeydown(e));
    
    // Obsługa scrolowania (uproszczona wersja Scroller)
    if (this.refs.container) {
      this.refs.container.addEventListener('scroll', () => this.handleScroll(), { passive: true });
    }

    console.log("CollectionLinks: Aktywne");
  }

  // Odpowiednik clamp z utilities
  clamp(val, min, max) {
    return Math.max(min, Math.min(max, val));
  }

  get currentIndex() {
    return this.refs.links.findIndex((link) => link.getAttribute('aria-current') === 'true');
  }

 select(targetIndex, event) {
    this.updateSelectedLink(targetIndex);
    
    // Pobieramy kontener, który się przewija (scroller)
    const scroller = this.querySelector('slideshow-slides');
    // Pobieramy wszystkie slajdy (używając nowej nazwy z init)
    const slides = this.refs.images; 

    if (scroller && slides[targetIndex]) {
      // Obliczamy pozycję slajdu względem początku scrollera
      const targetPath = slides[targetIndex].offsetLeft;
      
      scroller.scrollTo({
        left: targetPath,
        behavior: 'smooth' // Płynne przewinięcie
      });
    }

    if (event && event.type === 'mouseenter') {
      this.revealImage(event);
    }
  }

  updateSelectedLink(index) {
    const selectedIndex = this.clamp(index, 0, this.refs.links.length - 1);
    this.refs.links.forEach((link, i) => {
      link.setAttribute('aria-current', (i === selectedIndex).toString());
    });
  }

  handleKeydown(event) {
    let modifier = 0;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') modifier = 1;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') modifier = -1;

    if (!modifier) return;
    event.preventDefault();

    const nextIndex = this.clamp(this.currentIndex + modifier, 0, this.refs.links.length - 1);
    this.refs.links[nextIndex]?.focus();
    this.select(nextIndex);
  }

  handleScroll() {
    const containerRect = this.refs.container.getBoundingClientRect();
    const containerCenter = containerRect.left + containerRect.width / 2;

    let closestIndex = 0;
    let minDistance = Infinity;

    this.refs.links.forEach((link, index) => {
      const rect = link.getBoundingClientRect();
      const linkCenter = rect.left + rect.width / 2;
      const distance = Math.abs(containerCenter - linkCenter);

      if (distance < minDistance) {
        minDistance = distance;
        closestIndex = index;
      }
    });

    if (closestIndex !== this.currentIndex) {
      this.updateSelectedLink(closestIndex);
    }
  }

  clearSelections() {
    this.refs.links.forEach(link => link.setAttribute('aria-current', 'false'));
    this.refs.images.forEach(img => img.removeAttribute('reveal'));
  }

  revealImage(event) {
    const target = event.currentTarget;
    const index = this.refs.links.indexOf(target);
    const selectedImage = this.refs.images[index];

    if (!selectedImage) return;

    let rafId = null;

    const updatePosition = (e) => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        const offset = 15;
        selectedImage.style.setProperty('--x', `${e.clientX + offset}px`);
        selectedImage.style.setProperty('--y', `${e.clientY + offset}px`);
      });
    };

    const reset = () => {
      cancelAnimationFrame(rafId);
      selectedImage.removeAttribute('reveal');
      target.removeEventListener('mousemove', updatePosition);
    };

    selectedImage.setAttribute('reveal', '');
    target.addEventListener('mousemove', updatePosition);
    target.addEventListener('mouseleave', reset, { once: true });
  }
}

if (!customElements.get('collection-links-component')) {
  customElements.define('collection-links-component', CollectionLinks);
}